<template>
  <div id="project-guidance" >
    <div class="panel panel-default">
      <section class="panel-body">
        <h2>How do I create a project?</h2>
        <p>Click 'Add new project' and follow these steps to correctly add a new project:</p>
        <ol>
          <li>Enter details of the project
            <ul>
              <li>Name: Enter a name for the project.</li>
              <li>Description: Enter a description for the project.</li>
            </ul>
          </li>
          <li>Add a scoping document
            <ul>
              <li>Add a link or upload a file detailing the project scope.</li>
            </ul>
          </li>
          <li>Select Relevant Competencies (KSBs)
            <ul>
              <li>Use the table to select one or more competencies (Knowledge, Skills, and Behaviours) demonstrated by the project.</li>
            </ul>
          </li>
          <li>Save & Submit
            <ul>
            <li>Save as Draft if you need to return and edit later.</li>
              <li>Submit for Review once you are ready for your coach to review the project scope.</li>
            </ul>
          </li>
        </ol>
      </section>
    </div>
  </div>
</template>
